import { legacy_createStore as createStore, compose, applyMiddleware } from "redux";
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk, ThunkMiddleware } from "redux-thunk"; // ✅ fixed: named import
import rootReducer, { RootState } from "./reducers/rootReducers";

// persist configuration
const persistConfig: PersistConfig<RootState> = {
  key: "root",
  storage,
};

// create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// middleware
const middleware = [thunk as ThunkMiddleware<RootState, any>];

// enable Redux DevTools in development
const composeEnhancers =
  (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// create the store
export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

// create the persistor
export const persistor = persistStore(store);

// infer types for use throughout the app
export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
